import React, { useEffect } from "react";
import {useLocation} from "react-router";
import EmailVerification from "./emailVerification";
import OtpVerification from "./otpVerification";
import ResetPassword from "./resetPassword";
import SuccessMessage from "./successMessage";
import FailureMessage from "./failureMessage";


const FpRightSide = () => {
    const location = useLocation();

    return (
        <div className="flex items-start" style={{ height:location.pathname === "/forgotPassword" ?  "78vh" : "90vh"}} >
            {location.pathname === "/forgotPassword" && <EmailVerification />}
            {location.pathname === "/forgotPassword/otpVerification" && <OtpVerification />}
            {location.pathname === '/forgotPassword/resetPassword' && <ResetPassword />}
            {location.pathname === '/forgotPassword/successMessage' && <SuccessMessage />}
            {location.pathname === '/forgotPassword/failureMessage' && <FailureMessage />}       
        </div>
    )
}

export default FpRightSide;